import React, { useLayoutEffect } from 'react';

import ApplicationLayout from 'v3/layouts/Application';
import api from 'services/api';
import { DashboardArea, DashboardSection, Page, QuickAccessBand, VerticalRule } from './style';

import Favorites from './Favorites/Favorites';
import Recents from './Recents/Recents';
import MostAccessed from './MostAccessed/MostAccessed';

import config from '../../../config';

function Home() {
  async function savePushUserId() {
    const isPushNotificationsEnabled = localStorage.getItem('isPushNotificationsEnabled');
    const updatePushUserId = localStorage.getItem('updatePushUserId');
    if (isPushNotificationsEnabled && updatePushUserId) {
      const oneSignalPlayerId = localStorage.getItem('oneSignalPlayerId');
      const { push_user_id } = JSON.parse(localStorage.getItem('usuario'));
      if (oneSignalPlayerId !== push_user_id) {
        if (oneSignalPlayerId) {
          await api.put('user/add-user-id', {
            push_user_id: oneSignalPlayerId,
          });
          localStorage.setItem('updatePushUserId', false);
        }
      }
    }
  }

  useLayoutEffect(() => {
    savePushUserId();
  }, []);

  return (
    <ApplicationLayout title="Home" isOld>
      <Page>
        <QuickAccessBand>
          <MostAccessed />
        </QuickAccessBand>

        <DashboardArea>
          <DashboardSection>
            <Favorites />
          </DashboardSection>
          <VerticalRule />
          <DashboardSection>
            <Recents />
          </DashboardSection>
        </DashboardArea>

        <span
          style={{
            position: 'fixed',
            left: '80px',
            bottom: '2px',
            color: '#111',
            fontSize: '8px',
            userSelect: 'none',
            pointerEvents: 'none',
          }}
        >
          VERSÃO {config.versionNumber}
        </span>
      </Page>
    </ApplicationLayout>
  );
}

export default Home;
